import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { Modal } from 'ant-design-vue';

interface Props {
    visible?: boolean;
    informationType?: string;
    modalTitle?: string;
    message?: string;
    confirmEvent?: string;
    confirmPayload?: unknown;
    okText?: string;
    closable: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'InformationModal',
  props: {
    visible: { type: Boolean, default: false },
    informationType: { default: '' },
    modalTitle: { default: '' },
    message: { default: '' },
    confirmEvent: { default: 'confirm' },
    confirmPayload: { default: undefined },
    okText: { default: 'Ok' },
    closable: { type: Boolean, default: true }
  },
  emits: ["update:visible"],
  setup(__props: any, { emit }: { emit: ({
    (event: 'update:visible', value: boolean): void;
    (event: string, payload?: unknown): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { visible: boolean, informationType: string, modalTitle: string, message: string, confirmEvent: string, confirmPayload: unknown, okText: string, closable: boolean };





const internalVisible = computed({
    get: () => props.visible,
    set: (value: boolean) => emit('update:visible', value),
});

function confirm() {
    emit('update:visible', false);
    if (props.confirmEvent) {
        emit(props.confirmEvent, props.confirmPayload);
    }
}

return { __sfc: true,props, emit, internalVisible, confirm, Modal }
}

})